import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageResolverService } from './service/page-resolver.service';
import { DynamicPageLoaderComponent } from './shared/dynamic-page-loader/dynamic-page-loader.component';

export interface IRouteExtended {
  loadChildren: any,
  componentId: string;
}




export const route: Routes = [
  {path: "**", component: DynamicPageLoaderComponent, resolve: {data: PageResolverService}},
]

@NgModule({
  imports: [RouterModule.forRoot(route)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
